import React from "react";
import { ASSET_COLOR } from "./mockData.js";
import { fmtUSD2 } from "../../components/terminal/format.js";
import ItemActions, { CTX } from "../../components/terminal/ItemActions.jsx";

export default function PositionsPane({ positions = [], totalUsd, activeSym, onActiveSymChange }) {
  const total = totalUsd != null ? totalUsd : positions.reduce((a, p) => a + (parseFloat(p.usd) || 0), 0);

  return (
    <div className="term-pane">
      <div style={{ display:"grid", gridTemplateColumns:"1fr auto", gap:8, padding:14, borderBottom:"1px solid var(--term-line)", background:"var(--term-bg-pane)" }}>
        <div style={{ gridColumn:"1 / -1", fontSize:9.5, letterSpacing:"0.16em", color:"var(--term-ink-3)", textTransform:"uppercase", fontWeight:600 }}>
          TREASURY · USD BASE
        </div>
        <div className="mono" style={{ gridColumn:"1 / -1", fontSize:22, fontWeight:500, letterSpacing:"-0.015em", color:"var(--term-ink-1)", lineHeight:1 }}>
          ${total.toLocaleString("en-US", { minimumFractionDigits:2, maximumFractionDigits:2 })}
        </div>
        <div style={{ gridColumn:"1 / -1", display:"flex", gap:14, fontFamily:"JetBrains Mono", fontSize:10.5 }}>
          <span style={{ display:"inline-flex", alignItems:"center", gap:4 }}>
            <span style={{ color:"var(--term-ink-3)", fontSize:9.5, letterSpacing:"0.10em", textTransform:"uppercase" }}>24H</span>
            <span style={{ color:"var(--term-green)" }}>+ 0.32%</span>
          </span>
          <span style={{ display:"inline-flex", alignItems:"center", gap:4 }}>
            <span style={{ color:"var(--term-ink-3)", fontSize:9.5, letterSpacing:"0.10em", textTransform:"uppercase" }}>7D</span>
            <span style={{ color:"var(--term-green)" }}>+ 1.84%</span>
          </span>
          <span style={{ display:"inline-flex", alignItems:"center", gap:4 }}>
            <span style={{ color:"var(--term-ink-3)", fontSize:9.5, letterSpacing:"0.10em", textTransform:"uppercase" }}>MTD</span>
            <span style={{ color:"var(--term-red)" }}>− 0.42%</span>
          </span>
        </div>
      </div>
      <div className="term-pane-head">
        Positions
        <span className="meta"><b>{positions.length}</b> assets</span>
      </div>
      <div className="term-pane-body">
        <div style={{ display:"grid", gridTemplateColumns:"80px 1fr 90px 64px", gap:8, alignItems:"center", padding:"0 14px", height:22, fontSize:9.5, letterSpacing:"0.12em", color:"var(--term-ink-2)", textTransform:"uppercase", background:"var(--term-bg)", position:"sticky", top:0, zIndex:1, fontWeight:600, borderBottom:"1px solid var(--term-line-dim)" }}>
          <span>SYM</span><span>QTY</span><span style={{ textAlign:"right" }}>USD</span><span style={{ textAlign:"right" }}>24H</span>
        </div>
        {positions.map((p) => {
          const dec = (p.sym === "BTC" || p.sym === "ETH") ? 4 : (p.sym === "JPY" || p.sym === "AED") ? 0 : 2;
          const chg = parseFloat(p.chgPct) || 0;
          const chgColor = chg > 0 ? "var(--term-green)" : chg < 0 ? "var(--term-red)" : "var(--term-ink-3)";
          const sign = chg > 0 ? "+" : chg < 0 ? "−" : " ";
          const isActive = activeSym === p.sym;
          return (
            <div
              key={p.sym}
              className="term-has-ctx"
              onClick={() => onActiveSymChange?.(isActive ? null : p.sym)}
              style={{
                display:"grid", gridTemplateColumns:"80px 1fr 90px 64px", gap:8, alignItems:"center",
                padding:"0 14px", height:30, borderBottom:"1px solid var(--term-line-dim)",
                cursor:"pointer", fontFamily:"JetBrains Mono", fontSize:11.5,
                background: isActive ? "var(--term-bg-pane-2)" : "transparent",
                position:"relative",
              }}
            >
              {isActive && <span style={{ position:"absolute", left:0, top:0, bottom:0, width:2, background:"var(--term-green)" }} />}
              <span style={{ display:"inline-flex", alignItems:"center", gap:7, fontWeight:500, letterSpacing:"0.02em" }}>
                <span style={{ width:6, height:6, borderRadius:1, flexShrink:0, background: ASSET_COLOR[p.sym] || "var(--term-ink-3)" }} />
                {p.sym}
              </span>
              <span style={{ color:"var(--term-ink-2)", fontFamily:"Inter", fontSize:11, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>
                {Number(p.qty).toLocaleString("en-US", { minimumFractionDigits:dec, maximumFractionDigits:dec })}
              </span>
              <span style={{ textAlign:"right" }}>{fmtUSD2(p.usd)}</span>
              <span style={{ textAlign:"right", fontSize:10.5, color: chgColor }}>{sign} {Math.abs(chg).toFixed(2)}%</span>
              <span style={{ position:"absolute", right:6, top:"50%", transform:"translateY(-50%)", background:"var(--term-bg-pane-2)" }}>
                <ItemActions actions={CTX.position(p.sym)} />
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
